module.exports = __webpack_public_path__ + "img/47.977f35fe.jpg";